import { useState, useEffect } from "react"
import { createPortal } from "react-dom"
import {
  useGlobalContext,
  encryptUsername,
  decryptUsername,
  encryptPassword,
  decryptPassword,
} from "./GlobalContext"
import {  useLocation } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { handleLogout } from "../snippets/Logout"
import ModulesLotteryDraw from "../promotions/promotion_modules/modules_lotterDraw"
import Deposit from "../transactions/Deposit"
import LoginGlobal from "./LoginGlobal"
import DarkTheme from "./DarkTheme"
import Notification from "./Notification"
import { promoURL } from "../../App"
// import { useLeaderboard } from "./LeaderboardProvider"
// import { useLeaderboard } from "./LeaderboardProviderCQ9"
// import { useLeaderboard } from "./LeaderboardProviderJDB"
import { useLeaderboard } from "./LeaderboardProviderPP"
const dataUrl = process.env.REACT_APP_DATA_JSON_URL

const Login = () => {
  const {
    walletBalance,
    vipDetails,
    loading,
    username,
    handleReturnWallet,
    sg8Wallet,
    ascWallet,
    rtgWallet,
    goldenfWallet,
    sbsboWallet,
    customUsername,
    playerDetails,
    hasUnread,
    messages,
    markMessageAsRead,
  } = useGlobalContext()

  // Initialize login values from localStorage.
  // For username, we decrypt it.
  const initialRememberMe = localStorage.getItem("rememberMe") === "true"
  const initialUsername = localStorage.getItem("username")
    ? decryptUsername(localStorage.getItem("username"))
    : ""
  const initialPassword = initialRememberMe
    ? localStorage.getItem("password")
      ? decryptPassword(localStorage.getItem("password"))
      : ""
    : ""
  const { playerPosition, loadingBoard } = useLeaderboard()

  const [user, setUser] = useState({
    username: initialUsername,
    password: initialPassword,
  })
  const [rememberMe, setRememberMe] = useState(initialRememberMe)

  // Maintain local login state (isLoggedIn)
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("isLoggedIn") === "true"
  )

  const [ui, setUI] = useState({
    errorMessage: "",
    isLoginModalOpen: false,
    isDropdownOpen: false,
    isDropdownWalletOpen: false,
    dropdownTimer: null,
    loadingBalance: false,
    processingLogin: false,
  })
  const [isShowLogin, setIsShowLogin] = useState(true)
  const [isShowForgotPass, setIsShowForgotPass] = useState(false)
  const [isShowRegister, setIsShowRegister] = useState(false)
  const [activeModal, setActiveModal] = useState(null)
  const [phoneNo, setPhoneNo] = useState("")
  const [otpSent, setOtpSent] = useState(false)
  const [alertMsg, setAlertMsg] = useState("")
  const [successAlertMsg, setSuccessAlertMsg] = useState("")
  const [activePopup, setActivePopup] = useState(null)
  const [isDepositOpen, setIsDepositOpen] = useState(false)
  // These states are added for changing password.
  const [otp, setOtp] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [passwordChanged, setPasswordChanged] = useState(false)
  const [showNotication, setNotification] = useState(false)
  const [luckyDrawEntries, setLuckyDrawEntries] = useState()
  // const [showBonus, setShowBonus] = useState(false)

  const modalComponents = {
    "2/30 Lottery Draw": ModulesLotteryDraw,
  }
  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  useEffect(() => {
    if (isLoggedIn && !sessionStorage.getItem("lotteryModalShown")) {
      setActiveModal("2/30 Lottery Draw")
      sessionStorage.setItem("lotteryModalShown", "true")
    }
  }, [isLoggedIn])

  // Detect mobile view (width ≤ 1024px)
  const [mobileView, setMobileView] = useState(
    () => window.matchMedia("(max-width: 1024px)").matches
  )
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1024px)")
    const handleChange = (e) => setMobileView(e.matches)
    mediaQuery.addEventListener("change", handleChange)
    return () => {
      mediaQuery.removeEventListener("change", handleChange)
    }
  }, [])

  // Copy username to clipboard
  const handleCopyUsername = () => {
    navigator.clipboard
      .writeText(user.username)
      .then(() => alert("Username copied!"))
      .catch(() => alert("Failed to copy username."))
  }

  const HandleOpenRegister = () => {
    setIsShowLogin(false)
    setIsShowRegister(true)
  }

  const handleOpenForgotPass = () => {
    setIsShowLogin(false)
    setIsShowForgotPass(true)
  }
  const handleBackBtn = () => {
    setIsShowForgotPass(false)
    setIsShowLogin(true)
    setOtpSent(false)
    setPasswordChanged(false)
    setPhoneNo("")
  }
  useEffect(() => {
    if (ui.errorMessage) {
      const timer = setTimeout(() => {
        setUI((prev) => ({ ...prev, errorMessage: "" }))
      }, 10000)
      return () => clearTimeout(timer)
    }
  }, [ui.errorMessage])

  // Prevent background scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = ui.isLoginModalOpen ? "hidden" : ""
  }, [ui.isLoginModalOpen])

  // Redirect from protected pages if not logged in
  useEffect(() => {
    const protectedPaths = ["/profile"]
    if (protectedPaths.includes(window.location.pathname) && !isLoggedIn) {
      window.location.href = "/"
    }
  }, [isLoggedIn])

  // When logged in, update localStorage.
  // Here we store the username in encrypted form.
  useEffect(() => {
    if (isLoggedIn) {
      localStorage.setItem("isLoggedIn", "true")
      localStorage.setItem("username", encryptUsername(user.username))
      if (rememberMe) {
        localStorage.setItem("password", encryptPassword(user.password))
        localStorage.setItem("rememberMe", "true")
      } else {
        localStorage.removeItem("password")
        localStorage.setItem("rememberMe", "false")
      }
    } else {
      localStorage.removeItem("isLoggedIn")
      if (!rememberMe) {
        localStorage.removeItem("username")
        localStorage.removeItem("password")
      }
    }
    document.body.classList.toggle("IsLoggedIn", isLoggedIn)
  }, [isLoggedIn, user.username, user.password, rememberMe])

  const handleLogin = async (e) => {
    e.preventDefault()
    setUI((prev) => ({ ...prev, processingLogin: true }))
    try {
      const response = await fetch(dataUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          cmd: "loginjs",
          u: user.username,
          p: user.password,
        }),
      })
      if (!response.ok) throw new Error("Network response was not ok.")
      const data = await response.json()
      handleResponse(data)
    } catch (error) {
      setUI((prev) => ({
        ...prev,
        errorMessage: "Login failed. Please try again.",
      }))
    } finally {
      setUI((prev) => ({ ...prev, processingLogin: false }))
    }
  }

  const handleResponse = (data) => {
    if (data.s === "success") {
      setUser((prev) => ({
        ...prev,
        username: data.username,
        password: rememberMe ? prev.password : "",
      }))

      setIsLoggedIn(true)
      setUI((prev) => ({ ...prev, errorMessage: "", isLoginModalOpen: false }))
      updateAPILoginState(true)

      window.location.reload()
    } else {
      setUI((prev) => ({
        ...prev,
        errorMessage: data.emsg || "Login failed. Please try again.",
      }))
    }
  }

  const updateAPILoginState = (loggedIn) => {
    fetch(dataUrl, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        cmd: "updateLoginState",
        username: user.username,
        isLoggedIn: loggedIn,
      }),
    }).catch(console.error)
  }
  const onLogout = () => {
    handleLogout(username)
  }

  const menuItems = [
    {
      label: "Profile",
      link: "/profile",
      icon: "/images/icon/profile-icons.webp",
    },
    {
      label: "Logout",
      link: "#",
      icon: "/images/icon/logout-icons.webp",
      action: onLogout,
    },
  ]

  const walletItems = [
    { label: "Main Wallet", balance: sg8Wallet },
    { label: "ASC", balance: ascWallet },
    { label: "GOLDENF", balance: goldenfWallet },
    { label: "SBSBO", balance: sbsboWallet },
    { label: "RTG", balance: rtgWallet },
  ].filter((item, index) => {
    if (index === 0) return true
    const numBalance =
      parseFloat(item.balance?.toString().replace(/,/g, "")) || 0
    return numBalance > 0
  })

  walletItems.push({
    label: "Return to Main Wallet",
    link: "#",
    icon: "/images/icon/logout-icons.webp",
    action: () => handleReturnWallet(username),
  })

  const toggleLoginModal = () => {
    if (ui.isLoginModalOpen) {
      setIsShowLogin(true)
      setIsShowForgotPass(false)
      setIsShowRegister(false)
      if (!rememberMe) {
        setUser({ username: "", password: "" })
      }
      setUI((prev) => ({ ...prev, errorMessage: "" }))
    }
    setUI((prev) => ({ ...prev, isLoginModalOpen: !prev.isLoginModalOpen }))
  }

  const handleDropdown = (isVisible) => {
    if (ui.dropdownTimer) clearTimeout(ui.dropdownTimer)
    if (!isVisible) {
      const timer = setTimeout(
        () => setUI((prev) => ({ ...prev, isDropdownOpen: false })),
        300
      )
      setUI((prev) => ({ ...prev, dropdownTimer: timer }))
    } else {
      setUI((prev) => ({ ...prev, isDropdownOpen: true }))
    }
  }

  const handleGetOTP = async (e) => {
    e.preventDefault()
    let message = `OTP sent to [${phoneNo}]`

    // Validate phone number: Must be 11 characters and start with "0"
    if (phoneNo.length !== 11 || !phoneNo.startsWith("0")) {
      message = "Invalid Phone Number"
      setAlertMsg(message)
      return
    }

    // Create form data; this replicates the serialize() method
    const formData = new URLSearchParams()
    // You can append additional form fields if needed.
    formData.append("mobile", phoneNo)
    formData.append("cmd", "getOTP")

    try {
      const response = await fetch(dataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formData.toString(),
      })

      const data = await response.json()

      if (data.s === true) {
        setAlertMsg(message)
        setOtpSent(true)
      } else {
        message = "Invalid Phone Number"
        if (data.emsg) {
          message = data.emsg
        }
        setAlertMsg(message)
      }
    } catch (error) {
      console.error("Error fetching OTP:", error)
      setAlertMsg("An error occurred. Please try again.")
    }
  }

  const handleChangePass = async (e) => {
    e.preventDefault()
    // Ensure the new password and confirmation match
    if (newPassword !== confirmPassword) {
      setAlertMsg("Passwords do not match.")
      return
    }

    const formData = new URLSearchParams()
    formData.append("mobile", phoneNo)
    formData.append("cmd", "changepasswordWithOTP")
    formData.append("otp", otp)
    formData.append("password", newPassword)
    formData.append("confirmpassword", confirmPassword)

    try {
      const response = await fetch(dataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formData.toString(),
      })

      const data = await response.json()

      if (data.s) {
        setSuccessAlertMsg(data.s)
        // Clear the inputs once successful
        setOtp("")
        setNewPassword("")
        setConfirmPassword("")
        setAlertMsg("")
        setPasswordChanged(true)
      } else {
        setAlertMsg(data.e || "Password change failed. Please try again.")
      }
    } catch (error) {
      console.error("Error changing password:", error)
      setAlertMsg("An error occurred. Please try again.")
    }
  }

  const handleClick = () => {
    window.location.href = "/profile#wallet"
  }

  const handleShowNotification = async () => {
    setNotification(true)
  }

  const handleCloseNotification = () => {
    setNotification(false)
  }

  const handleWalletDropdown = (isVisible) => {
    if (ui.dropdownTimer) clearTimeout(ui.dropdownTimer)
    if (!isVisible) {
      const timer = setTimeout(
        () => setUI((prev) => ({ ...prev, isDropdownWalletOpen: false })),
        300
      )
      setUI((prev) => ({ ...prev, dropdownTimer: timer }))
    } else {
      setUI((prev) => ({ ...prev, isDropdownWalletOpen: true }))
    }
  }

  const { isDropdownOpen, isDropdownWalletOpen } = ui

  useEffect(() => {
    if (!isDepositOpen) return
    const prev = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = prev
    }
  }, [isDepositOpen])

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     fetch(promoURL, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  //       },
  //       body: `cmd=get8PromoCount&u=${user.username}`,
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (typeof data?.entries === "number") {
  //           setLuckyDrawEntries(data.entries)
  //         } else {
  //           console.error("No Entry data found.")
  //         }
  //       })

  //       .catch((error) => {
  //         console.error("Error fetching commission data:", error)
  //       })
  //   }
  // }, [isLoggedIn, username])

  // useEffect(() => {
  //   const updateCountdown = () => {
  //     const now = new Date()

  //     // Define today's 8PM and 12MN
  //     const today8PM = new Date()
  //     today8PM.setHours(20, 0, 0, 0) // 8:00:00 PM

  //     const today12PM = new Date()
  //     today12PM.setHours(24, 0, 0, 0) // 12:00:00 MN

  //     // Check if current time is between 8PM and 9PM
  //     if (now >= today8PM && now < today12PM) {
  //       setShowBonus(true)
  //     } else {
  //       setShowBonus(false)
  //     }
  //   }

  //   // Run immediately and every minute
  //   updateCountdown()
  //   const interval = setInterval(updateCountdown, 60 * 1000)

  //   return () => clearInterval(interval)
  // }, [])

    const location = useLocation()
    const isAppPromotion = location.pathname === "/app-promotion"

  return (
    <>
      {isDepositOpen &&
        createPortal(
          <div className="modal-portal">
            <Deposit
              onClose={() => setIsDepositOpen(false)}
              defaultBonusName="New Member Package Bonus"
            />
          </div>,
          document.body
        )}
      {showNotication && (
        <>
          <Notification onClose={handleCloseNotification} />
        </>
      )}
      <div className="user-data-wrapper">
        {/* {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />} */}

        {ActiveModal &&
          createPortal(
            <div className="modal-portal">
              <ActiveModal closeModal={() => setActiveModal(null)} />
            </div>,
            document.body
          )}

        {isLoggedIn ? (
          <div className="user-data-container">
            {/* Desktop view */}
            {!mobileView && (
              <div className="user-data-desktop">
                <div className="fgh-user-wallet">
                  <div
                    onMouseEnter={() => handleWalletDropdown(true)}
                    onMouseLeave={() => handleWalletDropdown(false)}
                  >
                    <strong className="fgh-user-balance common-btn">
                      <img src="/images/icon/peso-icons.webp" alt="Peso Icon" />{" "}
                      {loading ? "Preparing..." : sg8Wallet}
                      <a href="/profile/?=wallet" className="wallet-btn">
                        <img src="/images/icon/wallet-icons.webp" alt="" />
                      </a>
                    </strong>
                    {isDropdownWalletOpen && (
                      <div className="fgh-dropdown-menu-wallet">
                        <ul>
                          {walletItems.map((item, index) => (
                            <a
                              key={index}
                              href={item.link}
                              onClick={(e) => {
                                if (item.action) {
                                  e.preventDefault()
                                  item.action()
                                }
                              }}
                            >
                              <li>
                                <p>{item.label} </p>
                                <p>
                                  <strong>{item.balance}</strong>
                                </p>
                              </li>
                            </a>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="fgh-user-profile"
                  onMouseEnter={() => handleDropdown(true)}
                  onMouseLeave={() => handleDropdown(false)}
                >
                  <img
                    src={
                      vipDetails.vipImage || "/images/icon/vip/placeholder.webp"
                    }
                    className="fgh-vip-icon"
                    alt="VIP"
                  />
                  <strong className="fgh-data-username">{user.username}</strong>
                  {isDropdownOpen && (
                    <div className="fgh-dropdown-menu">
                      <ul>
                        {menuItems.map((item, index) => (
                          <a
                            key={index}
                            href={item.link}
                            onClick={(e) => {
                              if (item.action) {
                                e.preventDefault()
                                item.action()
                              }
                            }}
                          >
                            <li>
                              <img src={item.icon} alt={item.label} />{" "}
                              {item.label}
                            </li>
                          </a>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <DarkTheme />

                <div
                  className="notification-bell-desktop"
                  onClick={handleShowNotification}
                >
                  <img
                    src="/images/icon/notification-icons.webp"
                    alt="Notification"
                    className={` ${hasUnread ? "bell-ring" : ""}`}
                  />
                  {hasUnread && (
                    <span className="notification-indicator"></span>
                  )}
                </div>
              </div>
            )}
            {/* Mobile view */}
            {mobileView && (
              <div className="user-data-mobile">
                <div className="user-data-mobile-overlay"></div>
                <div className="fgh-mobile-header">
                  <div className="fgh-user-profile">
                    <img
                      src={
                        vipDetails.vipImage ||
                        "/images/icon/vip/placeholder.webp"
                      }
                      className="fgh-vip-icon"
                      alt="VIP"
                    />
                    <div className="fgh-user-profile-notice">
                      <strong className="fgh-data-username">
                        {user.username}
                        <button
                          className="copy-username-btn"
                          onClick={handleCopyUsername}
                        >
                          <img
                            src="/images/icon/copy.webp"
                            alt="Copy Username"
                          />
                        </button>
                      </strong>
                      <strong className="fgh-data-username custom-username">
                        {playerDetails.customUsername
                          ? `Hi ${playerDetails.customUsername}!`
                          : playerDetails.customUsername === ""
                            ? "Loading..."
                            : "Username is Not Set"}
                        {/* {playerPosition
                          ? `JDB: Rank#${playerPosition}`
                          : "Rank not found"} */}
                      </strong>
                      {/* <strong className="fgh-data-username custom-username">
                        Lucky 8 Entry {luckyDrawEntries}
                      </strong> */}
                      {/* <strong className="fgh-data-username custom-username">
                        {loadingBoard ? (
                          <p>Loading leaderboard...</p>
                        ) : playerPosition ? (
                          <p>Your CQ9 Rank: #{playerPosition}</p>
                        ) : (
                          <>
                            <p>Not on the leaderboard</p>
                            <p>CQ9 not ranked yet</p>
                          </>
                        )}
                      </strong> */}
                      {/* <strong className="fgh-data-username custom-username">
                        Lucky 8 Entry {luckyDrawEntries}
                      </strong> */}
                    </div>
                  </div>
                  <DarkTheme />
                  <div
                    className="fgh-notification-bell"
                    onClick={handleShowNotification}
                  >
                    <img
                      src="/images/icon/notification-icons.webp"
                      alt="Notification"
                      className={`notification-bell-icon ${
                        hasUnread ? "bell-ring" : ""
                      }`}
                    />
                    {hasUnread && (
                      <span className="notification-indicator"></span>
                    )}
                  </div>
                </div>
                <div className="fgh-mobile-wallet">
                  <div className="fgh-user-wallet">
                    {/* <div className="fgh-snow-melt">
                      <img src="/images/icon/SNOW-MELTING.webp" alt="" />
                    </div> */}
                    <strong className="fgh-mobile-balance">
                      <span className="fgh-mobile-balance-text">
                        Available Balance
                      </span>
                      {loading ? "Preparing..." : sg8Wallet}
                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          color: "#fff",
                        }}
                      >
                        <a
                          onClick={(e) => {
                            e.preventDefault()
                            handleReturnWallet(username)
                          }}
                          style={{
                            color: "#fff",
                            display: "flex",
                          }}
                        >
                          <img
                            style={{
                              width: "12px",
                              height: "12px",
                              marginRight: "3px",
                            }}
                            src="/images/icon/FGH-RETURN-ICON.webp"
                            alt=""
                          />
                          Return Wallet
                        </a>
                      </p>
                    </strong>
                  </div>
                  <button
                    className="fgh-mobile-deposit-btn"
                    onClick={() => setIsDepositOpen(true)}
                  >
                    <FontAwesomeIcon
                      icon={faPlus}
                      className="fa-deposit-icon"
                    />
                    Cash In
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <>

          {!isAppPromotion && (
             <div className="login-container">
              <div className="header-log-button">
                <a href="/" className="header-nav-logo">
                  <img src="/images/icon/fgh-logo.webp" alt="FGH Logo" />
                </a>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                {mobileView && <DarkTheme />}
                <LoginGlobal />
              </div>
              {!mobileView && (
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <DarkTheme />
                </div>
              )}
            </div>
          )}
           
          </>
        )}
      </div>
    </>
  )
}

export default Login
